// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"15aee952","99":"aecbc34b","317":"b7503e04","398":"e6908887","480":"8302f24e","787":"e104a259"}[chunkId] + ".chunk.js";
};